export default {
    brainedUserDetails: ""
}